module.exports = __webpack_public_path__ + "static/media/pic4.5c4b88f6.jpg";